<template>
  <!-- 2026-07-23 15:30：菜单翻译键缺失时使用功能名称，兼容已有本地缓存。 -->
  <div ref="menuHost" class="siderbar-menu">
    <a-menu
      mode="inline"
      :inline-indent="10"
      theme="dark"
      :inline-collapsed="!store.getters.sideBarOpened"
      v-model:openKeys="openKeys"
      v-model:selectedKeys="selectedKeys"
    >
    <template  v-for="(menu,index) in menus" >
      <a-sub-menu v-if="menu.children && menu.children.length>0"  :key="menu.path">
        <template #icon>
          <svg-icon  :class="[store.getters.sideBarOpened?'menu-icon':'plus-menu-icon']" :icon="menu.icon"></svg-icon> 
        </template>
        <template #title>{{generateTitle(menu.key || menu.title, menu.title)}}</template>
        <a-menu-item v-for="(submenu,sindex) in menu.children"  @click="menuClick(submenu,'ss'+sindex)" :key="submenu.path">{{generateTitle(submenu.key || submenu.title, submenu.title)}}</a-menu-item>
        
      </a-sub-menu>
      <a-menu-item v-else :key="'ss'+menu.path" @click="menuClick(menu,'k'+index)">
        <template #icon>          
              <svg-icon  :class="[store.getters.sideBarOpened?'menu-icon':'plus-menu-icon']" :icon="menu.icon"></svg-icon>          
        </template>
        <span>{{generateTitle(menu.key || menu.title, menu.title)}}</span>
      </a-menu-item>      
    </template>  
    </a-menu>
    <div class="org-info">{{ userInfo.roleName }}</div>
  </div>
</template>
<script lang="ts">
// 2026-10-19：按用户要求撤销快递100隐私发货任务，恢复原订单发货及既有功能。
import { useRouter, useRoute } from 'vue-router'
import { defineComponent, ref,reactive,toRefs,watch, computed, onMounted } from 'vue'
import { getMenus } from '@/utils/route'
import { generateTitle as translateTitle } from '@/utils/lang'
// 2026-09-17：平台新名称兼容旧菜单缓存，并移除已取消的初始化入口。
import { administrationTitleKey, isRetiredPlatformMenu, isBranchPlatformOnlyFunction } from '@/utils/platformAdministration'
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  MailOutlined,
  DesktopOutlined,
  InboxOutlined,
  AppstoreOutlined,
} from '@ant-design/icons-vue';
import store from '@/store'
import sysRequest from '@/api/sys'
import components from '@/components/index';
type MenuItem = {
  title:string,
  path:string,
  key:string,
  icon:string,
  expaned?:boolean,
  children?:Array<MenuItem>
}
export default defineComponent({
  setup() {
    const router = useRouter()
    const route = useRoute()
    const routes = getMenus(router.getRoutes())
    // 2026-09-17：保留接口菜单名称作为缺失翻译的兜底，兼容生产商已有登录缓存。
    const generateTitle=(title,fallbackTitle?:string)=>translateTitle(administrationTitleKey(title,store.getters.userInfo.orgId),fallbackTitle)
    const openKeys = ref<string[]>([])
      const state = reactive({
      collapsed: false,
      selectedKeys: ['/platform/platforminfo'],
      openKeys: ['/platform/platforminfo'],
      preOpenKeys: ['sub1'],
    });
    const menuClick = (menu:MenuItem,key:string) => {
      if (!menu.children) {
        if(menu.path==='/products/bokes'){
          router.push({  
            path: menu.path,  
            query: {productType:0}
          });
        }else{
          router.push(menu.path)
        }
        
      }
    }
    const userInfo=computed(()=>{
      return store.getters.userInfo
    })
      
    watch(
      () => state.openKeys,
      (val, oldVal) => {
        state.preOpenKeys = oldVal;
      },
    );
    const menus = ref<MenuItem[]>([])
    const menuHost = ref<HTMLElement>()
    // 按已授权菜单的实际字体测量，包含未展开的子菜单；不改变菜单数据或权限。
    const fitMenuWidth = () => {
      const host = menuHost.value?.querySelector('.ant-menu')
      if (!host || !menus.value.length) return
      const context = document.createElement('canvas').getContext('2d')
      if (!context) return
      const font = getComputedStyle(host)
      context.font = `${font.fontWeight} ${font.fontSize} ${font.fontFamily}`
      let width = 100
      menus.value.forEach(menu => {
        width = Math.max(width, context.measureText(generateTitle(menu.key || menu.title, menu.title)).width + 54)
        menu.children?.forEach(child => {
          width = Math.max(width, context.measureText(generateTitle(child.key || child.title, child.title)).width + 46)
        })
      })
      document.body.style.setProperty('--sidebar-expanded-width', Math.ceil(width) + 'px')
    }
    watch([menus, () => store.getters.language], fitMenuWidth, {deep:true, flush:'post'})
    const openMenu = (menu) => {
      let index = openKeys.value.indexOf(menu.path)
      if (index != -1) {
        openKeys.value.splice(index, 1)
      } else {
        openKeys.value = [menu.path]
      }
    }
    const expaned = (menu) => {
      menu.expaned=!menu.expaned;
    }
    // 2026-08-30：分店旧登录缓存即使仍含VIP角色总控，也不能继续生成该平台超管专属菜单。
    const visibleFunctions=()=>{
      const platformSuperAdministrator=Number(store.getters.userInfo.orgId)===1000
        && Number(store.getters.userInfo.roleId)===1
      return (store.getters.functions.allFunc||[]).filter(item=>
        (platformSuperAdministrator||item.functionKey!=='platform.orgrights')
        && !isRetiredPlatformMenu(store.getters.userInfo,item)
        // 2026-09-20：分店历史授权/登录缓存不能继续显示平台系统参数入口。
        && !isBranchPlatformOnlyFunction(store.getters.userInfo,item))
    }
    // 2026-09-17：分店旧登录缓存也把已授权的平台商品放在商品管理首位，不新增入口或调整其他菜单。
    const placePlatformProductsFirst=()=>{
      if(!(Number(store.getters.userInfo.orgId)>1000)) return
      const children=menus.value.find(item=>item.path==='/products')?.children
      const index=children?.findIndex(item=>item.path==='/products/parentSharedprds') ?? -1
      if(children && index>0) children.unshift(children.splice(index,1)[0])
    }
    const getAllFunctions =async () =>{
        const funcs=[...store.getters.functions.parentFunc]
        // 2026-09-17：平台二级菜单按正式版登录时的SortIndex升序生成，兼容顺序已变化的权限缓存。
        const functions=visibleFunctions()
        if(Number(store.getters.userInfo.orgId)===1000) functions.sort((left,right)=>left.sortIndex-right.sortIndex)
        functions.forEach(itm=>{
          if(itm.functionType=='MENU'){
            funcs.push(itm)
          }         
        })
        menus.value=funcs.reduce((acc,item)=>{          
          if(item.parentId==0){
            acc.push({title:item.functionName,key:item.functionKey, path:item.functionUrl,icon:item.icon,parentId:item.parentId,id:item.id})
          }else{
            const itm=acc.find(itm=>itm.id==item.parentId)
            if(itm){
              if(!itm.children)
                itm.children=[]
              itm.children.push({title:item.functionName,key:item.functionKey,path:item.functionUrl,icon:item.icon,parentId:item.parentId,id:item.id})
            }
          }
          return acc
        },[])  
        for(let i=0;i<menus.value.length;i++){
          if(!menus.value[i].children || menus.value[i].children?.length==0){
            menus.value.splice(i,1)
            i--;
          }
        } 
        placePlatformProductsFirst()
        console.log(menus.value)
    }
    const getRoleFunctions = async (roleId) => {      
      const fs=visibleFunctions().sort((b,a)=>{
          return b.sortIndex-a.sortIndex
        })
        const funcs=[...store.getters.functions.parentFunc]
        fs.forEach(itm=>{
          if(itm.functionType=='MENU'){
            funcs.push(itm)
          }        
        })
        menus.value=funcs.reduce((acc,item)=>{          
          if(item.parentId==0){
            acc.push({title:item.functionName,key:item.functionKey,path:item.functionUrl,icon:item.icon,parentId:item.parentId,id:item.id})
          }else{
            const itm=acc.find(itm=>itm.id==item.parentId)
            if(itm){
              if(!itm.children)
                itm.children=[]
              itm.children.push({title:item.functionName,key:item.functionKey,path:item.functionUrl,icon:item.icon,parentId:item.parentId,id:item.id})
            }
          }
          return acc
        },[])    
        for(let i=0;i<menus.value.length;i++){
          if(!menus.value[i].children || menus.value[i].children?.length==0){
            menus.value.splice(i,1)
            i--;
          }
        }  
        placePlatformProductsFirst()
    }
    onMounted(() => {
      document.fonts?.ready.then(fitMenuWidth)
      if(store.getters.userInfo.roleId==1){  //如果是管理员，直接取所有菜单
        getAllFunctions()
      }else{
        getRoleFunctions(store.getters.userInfo.roleId)
      }
    })
    return {
      menuHost, menuClick, ...toRefs(state),openMenu, store, generateTitle, openKeys, routes, route,menus,expaned,userInfo
    }
  },
  components:{
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    PieChartOutlined,
    MailOutlined,
    DesktopOutlined,
    InboxOutlined,
    AppstoreOutlined,
  }
})

</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables.module.scss';
.siderbar-menu {
  cursor: pointer;
  height:calc(100vh - 70px);
  display:flex; flex-direction:column;
  :deep(> .ant-menu) { flex:1; min-height:0; overflow-y:auto; overflow-x:hidden; }
  .org-info { color:lightgray; padding:8px 4px; box-sizing:border-box; font-size:11px; line-height:16px; text-align:center; white-space:normal; overflow-wrap:anywhere; flex:0 0 auto; }
  .siderbar-submenu {
    position: relative;
    padding: 8px 0;
  }

  .siderbar-menu-item {
    position: relative;
    box-sizing: border-box;
    background-color: $menuBg;
    color: #fff;
    &:first-child {
      margin-top: 0;
    }
  }

  .siderbar-menu-item-title {
    box-sizing: border-box;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    white-space: nowrap;
  }
  .siderbar-submenu-item-title{
    box-sizing: border-box;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    white-space: nowrap;
    margin-left:20px;
  }
  .siderbar-menu-title-content {
    margin-left: 10px;
  }

  .siderbar-child-menu-title-content {
    margin-left: 48px;
  }

  .active-menu-item {   
    color: white;
    .siderbar-menu-item-title {
      
      background: #1890ff;
    }
  }

  .menu-icon {
    font-size: 14px !important;
  }

  .plus-menu-icon {
    font-size: 18px !important;
    
  }
  
  .right-arrow-icon {
    position: absolute;
    right: 12px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
